import React, { useState } from "react";
import { Row, Col, InputGroup, Input, InputGroupAddon, InputGroupText } from "reactstrap";
import { connect } from "react-redux";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import { Tooltip } from "@material-ui/core";
import FileStorageWrapper from "../FileStorage/FileStorageWrapper";
import PhotoLibraryOutlinedIcon from "@material-ui/icons/PhotoLibraryOutlined";
import "./UrlMultiInput.css";

const UrlMultiInput = ({
  url,
  onChange,
  setImage,
  noInfoText = false,
  path,
  onOpen = null,
  externalSourceOnly = false,
  margin = true,
  cropSizes = null,
  rowStyle = {},
  colStyle = {},
  dark = false,
}) => {
  const [vaultOpen, setOpen] = useState(false);
  const toggle = () => {
    setOpen(!vaultOpen);
    if (onOpen && typeof onOpen == "function") onOpen(!vaultOpen);
  };
  const handlePaste = () => {
    navigator.clipboard.readText().then((text) => {
      if (text.includes("https://") || text.includes("data:image/")) {
        if (path) {
          onChange(null, text, path);
        } else {
          onChange(text);
        }
      }
    });
  };
  const handleInput = (e) => {
    let text = e.target.value;
    if (path) {
      onChange(null, text, path);
    } else {
      onChange(text);
    }
  };
  return (
    <Row style={{ ...rowStyle, marginTop: margin === false ? "0px" : "15px" }}>
      <Col className="list-setting-item-title" style={colStyle}>
        <InputGroup>
          <Tooltip title={<SystemLabel name="InsertImageUrlOrUpload" />}>
            <Input autoComplete="jirango-nofill" onChange={(e) => handleInput(e)} value={url} />
          </Tooltip>
          {externalSourceOnly === false ? (
            <InputGroupAddon onClick={toggle} addonType="append">
              <InputGroupText
                className="jirango-prepend"
                style={
                  dark
                    ? {
                        backgroundColor: "transparent",
                        cursor: "pointer",
                        border: "0px",
                        color: "#eeee",
                      }
                    : {
                        backgroundColor: "#fff",
                        cursor: "pointer",
                        border: "1px solid #e4e7ea",
                      }
                }
              >
                <PhotoLibraryOutlinedIcon style={{ color: dark ? "#ffffff99" : undefined }} className="prepend-icon" />
              </InputGroupText>
            </InputGroupAddon>
          ) : null}
        </InputGroup>
        {!noInfoText ? (
          <p className="text-muted" style={{ lineHeight: "initial", marginTop: "5px" }}>
            <SystemLabel name="UrlLinkInfo" />
          </p>
        ) : null}
      </Col>
      {vaultOpen ? <FileStorageWrapper toggle={toggle} cropSizes={cropSizes} typeRequest="img" onUseSelected={setImage} showLaunchBtn={false} isOpen={vaultOpen} /> : null}
    </Row>
  );
};
function mapStateToProps(state) {
  return {
    cms: state.cms,
    eventId: state.cms.eventId,
  };
}
export default connect(mapStateToProps)(UrlMultiInput);
